module.exports = __webpack_public_path__ + "img/Suriname.4d0228fd.gif";